import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

// Auth Components
import { loginRequest } from "../../utils/azureConfig";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

// UI components
import { Button } from "react-bootstrap";
import MicrosoftLogo from "./MicrosoftLogo.png";

// State
import { ssoComplete } from "../../state/actions/user";
import { blockUI, releaseUI } from "../../state/actions/globals";

// Helpers
import { error, Group } from "../../utils/logger";
import { toastr } from "react-redux-toastr";
const LoggerGroup = new Group("LogIn: Microsoft", { disable: false });

const LogInMicrosoft = ({ user, ssoComplete, blockUI, releaseUI }: any) => {
  const { instance, accounts } = useMsal();
  const isAuthenticatedSSO = useIsAuthenticated();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const clearSession = useCallback(() => {
    console.warn("Cleaning up SSO details");

    // TODO: more targeted approach to this?
    sessionStorage.clear();

    instance
      .logoutRedirect({
        // Return false if you would like to stop navigation after local logout
        onRedirectNavigate: () => false,
      })
      .catch(console.error);
  }, [instance]);

  const handleError = useCallback(
    (err: Error) => {
      error("HANDLE ERROR", err);
      // setIsLoggedIn(false);
      releaseUI();
      clearSession();
      toastr.error("Unable to authenticate", err.message);
    },
    [clearSession, releaseUI]
  );

  // TODO: Fix bugs: UI stays blocked if auth fails
  useEffect(() => {
    if (isLoggedIn) {
      return; // Already logged in
    }

    if (isAuthenticatedSSO && !user.isAuthenticated) {
      blockUI();
      setIsLoggedIn(true);

      LoggerGroup.emit("-- Acquiring Microsoft SSO token");

      instance
        .acquireTokenSilent({
          account: accounts[0] as any,
          scopes: ["User.Read", "Directory.AccessAsUser.All"],
        })
        .then(ssoComplete.bind(null, "azure"))
        .then(clearSession)
        .catch(handleError);
    }

    LoggerGroup.end();
  }, [
    accounts,
    instance,
    ssoComplete,
    isLoggedIn,
    isAuthenticatedSSO,
    user.isAuthenticated,
    clearSession,
    blockUI,
    handleError,
  ]);

  const handleLogin = (loginType: string) => {
    blockUI();

    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch(handleError);
    } else if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch(handleError);
    }
  };

  // User is logged in, redirect to internal endpoint
  if (user.isAuthenticated) {
    return <Redirect to="/home" />;
  }

  return (
    <Button variant="outline-secondary" onClick={() => handleLogin("popup")}>
      <img src={MicrosoftLogo} alt="Microsoft Logo" className="mr-2" style={{ height: "20px" }} />
      Sign in with Microsoft
    </Button>
  );
};

LogInMicrosoft.propTypes = {
  user: PropTypes.object.isRequired,
  // ssoUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state: any) => ({
  user: state.user,
});

export default connect(mapStateToProps, { ssoComplete, blockUI, releaseUI })(LogInMicrosoft);
